<template>
  <v-col v-show="addonActive" cols="12">
    <div :style="addonContainerStyles">
      <slot name="default" :resetKey="addonKey"></slot>
    </div>
  </v-col>
</template>

<script lang="ts">
import { defineComponent, PropType, watch } from "vue"
import { useWysiwygAddon } from "features/wysiwyg/addon/wysiwyg-addon.concern"
import { RegisterWysiwygAddonFunction } from "features/wysiwyg/addon/wysiwyg-addon.types"
import THEME from "constants/theme"

export default defineComponent({
  name: "WysiwygAddon",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    registerAddon: {
      type: Function as PropType<RegisterWysiwygAddonFunction>,
      required: true,
    },
    badgeCount: {
      type: Number,
      required: false,
    },
    initialActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const { addonKey, setBadgeCount, resetAddon, addonActive, addonMenuItem } =
      useWysiwygAddon(props.title, props.icon, props.initialActive)

    props.registerAddon({
      addonMenuItem,
      resetAddon,
    })

    watch(
      () => props.badgeCount,
      (newCount) => {
        setBadgeCount(newCount)
      },
      { immediate: true }
    )

    const addonContainerStyles = {
      backgroundColor: "#FFFFFF",
      borderRadius: "4px",
      border: `1px solid ${THEME.colors.light.mediumGrey}`,
      padding: "32px",
    }

    return {
      addonActive,
      addonKey,
      addonContainerStyles,
    }
  },
})
</script>
